import { formatPrice } from "FrontendJsAssets/common/format";
import { replaceTranslate } from "Functions/replaceTranslate";
import { thumbnail } from "Functions/thumbnail";
import BranchReservationStore from "VueComponents/BranchReservation/_store";

const branchReservationEl = document.querySelector(".vue-branch-reservation");
let hasInitializationStarted = false;

if (branchReservationEl) {
    $("#product-reservation").on("show.bs.modal", async () => {
        if (hasInitializationStarted) {
            return;
        }
        hasInitializationStarted = true;

        const authData = JSON.parse(branchReservationEl.dataset.authData);

        if (authData.email && localStorage.getItem("reservation-email") === null) {
            localStorage.setItem("reservation-email", authData.email);
        }
        if (authData.phone && localStorage.getItem("reservation-phone") === null) {
            localStorage.setItem("reservation-phone", authData.phone);
        }

        const { Vue, i18n } = await import("Common/vue");
        const { default: BranchReservation } = await import(
            "VueComponents/BranchReservation/Index"
        );

        Vue.use({
            install(Vue) {
                Vue.prototype.replaceTranslate = replaceTranslate;
                Vue.prototype.formatPrice = formatPrice;
                Vue.prototype.thumbnail = thumbnail;
            },
        });

        window.$_branchReservation = new Vue({
            i18n: i18n,
            store: BranchReservationStore,
            render: (h) => h(BranchReservation),
        }).$mount(branchReservationEl);

        BranchReservationStore.dispatch("retrieveCurrentReservation");
    });
}

for (const openModalEl of document.querySelectorAll(".js-open-modal-reservation")) {
    openModalEl.addEventListener("click", (event) => {
        event.preventDefault();

        BranchReservationStore.dispatch("retrieveCurrentReservation");
        $("#product-reservation").modal("show");
    });
}

for (const addToReservationEl of document.querySelectorAll(".js-add-to-reservation")) {
    addToReservationEl.addEventListener("click", (event) => {
        event.preventDefault();

        if (addToReservationEl.classList.contains("is-disabled")) {
            return;
        }

        const { productId } = addToReservationEl.dataset;

        BranchReservationStore.dispatch("addProductToReservation", { productId }).then(
            ({ data: responseData }) => {
                BranchReservationStore.dispatch("showAlert", {
                    message: responseData.message,
                    tippyOptions: {
                        theme: responseData.status ? "success" : "error",
                    },
                    delay: responseData.status ? 4000 : 10000,
                });
            }
        );

        $("#product-reservation").modal("show");
    });
}
